import { createStore, withProps, select } from '@ngneat/elf';
import { BasketModel, createBasket } from '../model';
import { Env } from '../../../env';
import { filter } from 'rxjs/operators';

export interface BasketState extends BasketModel {
  loading: boolean;
}

const initialBasket = createBasket({}, Env.Currency);
const store = createStore(
  { name: 'basket' },
  withProps<BasketState>({ ...initialBasket, loading: false })
);

const basketWithPrice$ = store.pipe(
  select((state) => state),
  filter((basket) => !!basket.price && !basket.loading)
);

const basketIsLoading$ = store.pipe(select((state) => state.loading));

const setLoadingInBasket = (loading: boolean) =>
  store.update((state) => ({ ...state, loading }));

const updateBasket = (basket: BasketModel) =>
  store.update((state) => ({ ...state, ...basket }));

export const BasketRepository = {
  store,
  basketWithPrice$,
  basketIsLoading$,
  setLoadingInBasket,
  updateBasket,
};
